
const Hero = () => {
    return ( 
        <section id='jumbo'>
            <div>
                <h1>Have any project in <span>mind</span>?</h1>
                <a href="" className='jumbo-btn'>Talk to Me!</a>
            </div>
        </section>
       
     );
}
 
export default Hero;